import React from 'react';

import type { LumappsComponentProperties } from '@lumapps/micro-apps/types';

import type { LumappsComponentBaseProps, LumappsComponentProps } from '../../types';
import { components as choices } from './components';
import { LumappsComponentUnavailable } from './LumappsComponentUnavailable';

/**
 * Get a LumApps Component by its type.
 */
export const getLumappsComponent = (componentType: LumappsComponentProperties['type']) =>
    choices[componentType]?.component ?? LumappsComponentUnavailable;

/**
 * Get an array of LumApps Component settings by their types.
 */
export const getLumappsComponentSettings: (componentType: LumappsComponentProperties['type']) => {
    component: React.FC<LumappsComponentProps<typeof componentType>>;
    settings?: React.FC<LumappsComponentBaseProps<typeof componentType>>;
} = (componentType: LumappsComponentProperties['type']) => choices[componentType];
